import { useEffect, useState } from "react";
import mascotRepairServer from "../Assets/icons/okkali_mascot_repairserver.png";

const ServerMaintenancePage = () => {
  const [dots, setDots] = useState("");
  const [bounce, setBounce] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? "" : prev + "."));
    }, 600);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const t = setInterval(() => setBounce((p) => !p), 2500);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gradient-to-br from-amber-50/60 via-white to-orange-50/40 select-none">
      <div className="flex flex-col items-center gap-6 sm:gap-8 px-6 text-center max-w-lg w-full">
        <div className={`transition-transform duration-1000 ease-in-out ${bounce ? "-translate-y-2" : "translate-y-0"}`}>
          <img
            src={mascotRepairServer}
            alt="Sunucu bakımda"
            className="w-48 h-48 sm:w-60 sm:h-60 md:w-72 md:h-72 object-contain drop-shadow-2xl mx-auto"
            draggable={false}
          />
        </div>

        <div className="space-y-3">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-amber-900">
            Sunucu Güncelleniyor
          </h1>
          <p className="text-amber-800/70 text-base sm:text-lg leading-relaxed max-w-md mx-auto">
            Sistem bakım ve güncelleme çalışması yapılmaktadır.
            <br className="hidden sm:block" />
            Kısa süre içinde tekrar hizmetinizde olacağız.
          </p>
        </div>

        <div className="w-full max-w-xs space-y-3">
          <div className="flex items-center justify-center gap-3 bg-amber-50 backdrop-blur-sm px-6 py-3.5 rounded-2xl border border-amber-200/60 shadow-sm">
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-3 w-3 bg-amber-500" />
            </span>
            <span className="text-sm sm:text-base text-amber-700 font-medium">
              Bağlantı kontrol ediliyor{dots}
            </span>
          </div>

          <div className="h-1.5 w-full bg-amber-100 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-amber-400 to-orange-400 rounded-full animate-[indeterminate_1.5s_ease-in-out_infinite]" />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes indeterminate {
          0% { width: 0%; margin-left: 0; }
          50% { width: 60%; margin-left: 20%; }
          100% { width: 0%; margin-left: 100%; }
        }
      `}</style>
    </div>
  );
};

export default ServerMaintenancePage;
